import { Grid, IconButton, Tooltip } from "@mui/material";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";

type ResetFiltersProps = {
  handleClick: () => void;
};

export const ResetFilters = ({ handleClick }: ResetFiltersProps) => (
  <Grid item mt={0.55}>
    <Tooltip title="RESET FILTERS">
      <span>
        <IconButton onClick={() => handleClick()}>
          <FilterAltOffIcon />
        </IconButton>
      </span>
    </Tooltip>
  </Grid>
);
